import 'bootstrap';
import './scss/app.scss';
import './scss/main.scss';
import './scss/main-responsive.scss';

import * as jQuery from 'jquery';
window['jQuery'] = jQuery;
var $ = require('jquery');

import Swiper from 'swiper';
require('magnific-popup');

var imagesLoaded = require('imagesloaded');
imagesLoaded.makeJQueryPlugin($);
require('magnific-popup');

//Navigation
$(function () {
    const $navigation = $('.navbar-menu');
    const $body = $('body');
    const $trigger = $('[data-toggle="navbar-menu"]');

    let a, b;

    function toggleMenu(e) {
        e.preventDefault();

        if (!$body.hasClass('menu-is-open')) {
            clearTimeout(b);

            $body.addClass('menu-is-open');
            $navigation.css('display', 'block');

            a = setTimeout(function () {
                $navigation.addClass('menu-open');
            }, 50);
        } else {
            $body.removeClass('menu-is-open');
            $navigation.removeClass('menu-open');

            b = setTimeout(function () {
                $navigation.css('display', '');
            }, 400);
        }
    }

    $trigger.bind('click', toggleMenu);
});

//Swiper - Popular Categories
$(function() {
    var swiperWrapper = $('.swiper-popular-wrapper'),
        swiper;

    if (swiperWrapper.length > 0) {
        swiper = new Swiper('.swiper-popular', {
            loop: true,
            speed: 400,
            slidesPerView: 'auto',
            slideToClickedSlide: true,
            centeredSlides: true,
            cssWidthAndHeight: true,
            navigation: {
                nextEl: '.swiper-popular-wrapper .swiper-btn-next',
                prevEl: '.swiper-popular-wrapper .swiper-btn-prev',
            },
        });
    }
});

//Swiper - Blog Posts
$(function() {
    var swiperWrapper = $('.swiper-blog-wrapper'),
        swiper;

    if (swiperWrapper.length > 0) {
        swiper = new Swiper('.swiper-blog', {
            loop: true,
            speed: 400,
            slidesPerView: 'auto',
            noSwipingClass: 'swiper-blog',
            slideToClickedSlide: true,
            centeredSlides: true,
            cssWidthAndHeight: true,
            navigation: {
                nextEl: '.swiper-blog-wrapper .swiper-btn-next',
                prevEl: '.swiper-blog-wrapper .swiper-btn-prev',
            },
        });
    }
});

//Swiper - Product Page
$(function() {
    var swiperWrapper = $('.swiper-product-gallery-wrapper'),
        swiper;

    if (swiperWrapper.length > 0) {
        swiper = new Swiper('.swiper-product-gallery', {
            speed: 1000,
            slidesPerView: '1',
            noSwipingClass: 'swiper-product-gallery',
            cssWidthAndHeight: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            navigation: {
                nextEl: '.swiper-product-gallery-wrapper .swiper-btn-next',
                prevEl: '.swiper-product-gallery-wrapper .swiper-btn-prev',
            },
            pagination: {
                el: '.swiper-product-gallery-wrapper .swiper-pagination',
                clickable: true,
            }
        });
    }
});

//Load single div backgrounds
$(function () {
    var image = document.querySelectorAll('img[data-bg="true"], [data-bg="true"], .gallery-photo > img');

    for (var i = 0; i < image.length; i++) {
        (function (n) {
            var img = new Image();

            img.onload = imageFound;
            img.onerror = imageNotFound;
            img.src = image[n].src;

            function imageFound() {
                image[n].parentNode.style.backgroundImage = 'url(' + img.src + ')';

                if ($(image[n]).parent().is('.bg')) {
                    $(image[n]).parent().css({
                        opacity: '1'
                    });
                }
            }

            function imageNotFound() {
                image[n].parentNode.style.backgroundColor = '#0F1418';
            }
        }(i));
    }
});

//Load section backgrounds
$(function () {
    var section = document.querySelectorAll('div[data-section-bg], section[data-section-bg], [data-section-bg]');

    for (var i = 0; i < section.length; i++) {
        (function (n) {
            var img = new Image();
            var sectionBG = document.createElement('div');

            sectionBG.classList.add('section-bg');

            img.onload = imageFound;
            img.onerror = imageNotFound;
            img.src = section[n].getAttribute('data-section-bg');

            function imageFound() {
                section[n].append(sectionBG);
                sectionBG.style.backgroundImage = 'url(' + img.src + ')';
            }

            function imageNotFound() {
                sectionBG.style.backgroundColor = '#0F1418';
            }
        }(i));
    }
});

//Form control
$(function () {
    var field = $('input, textarea');

    field.on('focus', function () {
        var that = $(this);

        that.closest('.form-group').addClass('is-focus');
    });

    field.on('blur', function () {
        var that = $(this);

        if (that.val().length === 0) {
            that.closest('.form-group').removeClass('is-focus');
        } else {
            that.closest('.form-group').addClass('is-filled');
        }
    }).trigger('blur');

    field.on('keyup keydown', function () {
        var that = $(this);

        if (that.val().length === 0) {
            that.closest('.form-group').removeClass('is-filled');
        } else {
            that.closest('.form-group').addClass('is-filled');
        }
    });
});

//Truncate text
$(function () {
    var newsBlock = $('.news-post-block');

    function truncateText(item, truncateLength, firstLetter) {
        $.each(item, function () {
            var el = $(this),
                elP = el.find('p'),
                elPText = elP.text(),
                elPTextTrimmed = $.trim(elPText);

            if (firstLetter) {
                elP.html('<span class="first-letter">' + elPTextTrimmed.substr(0, 1) + '</span>' + elPTextTrimmed.substr(1, truncateLength) + '...');
            } else {
                elP.html(elPTextTrimmed.substr(0, truncateLength) + '...');
            }
        });
    }

    truncateText(newsBlock, 130, false);
});

//Same height titles
$(function () {
    var newsBlock = $('.news .news-post-block');

    function setTitleMinHeight(element) {
        element.find('h6').css({
            minHeight: ''
        });
        $.each(element, function () {
            var el = $(this);

            var heights = el.find('h6').map(function () {
                return $(this).height();
            }).get();

            var maxHeight = Math.max.apply(null, heights);

            element.find('h6').css({
                minHeight: maxHeight + 'px'
            });
        });
    }

    $(window).on('resize', function(){
        setTitleMinHeight(newsBlock);
    }).trigger('resize');
});

//Gallery profile masonry
$(function () {
    var grid = document.querySelector('.gallery');

    if ($(grid).length > 0) {
        var msnry = new Masonry(grid, {
            itemSelector: '.gallery-item',
            columnWidth: '.gallery-sizer',
            gutter: 0,
            percentPosition: true
        });

        imagesLoaded(grid).on('progress', function () {
            msnry.layout();
        });
    }
});

//Profile Gallery
$(function () {
    var galleryItem = $('.gallery-item');

    if (galleryItem.length > 0) {
        galleryItem.magnificPopup({
            type: 'image',
            gallery: {
                enabled: true,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-custom-arrow mfp-custom-arrow-%dir%"></button>'
            },
        });
    }
});
//Increment/Decrement
$(function () {
    $(".product-quantity-more").append('<div class="inc button">+</div><div class="dec button">-</div>');

    $(".button").on("click", function () {

        let $button = $(this);
        let oldValue = $button.parent().find("input").val();

        let newVal = 0;

        if ($button.hasClass('inc')) {
            newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
                newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }

        $button.parent().find("input").val(newVal);
    });

    $('[data-quantity="more"]').on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $(this).text('Reset');
            $('.product-quantity').css({display: 'none'});
            $('.product-quantity-more').css({display: 'flex'});
        } else {
            $(this).removeClass('active');
            $(this).text('Want More?');
            $('.product-quantity').css({display: ''});
            $('.product-quantity-more').css({display: ''});
        }
    });
});

//Side navigation toggler
$(function() {
    var toggler = document.querySelectorAll('[data-toggle="side-navigation"], div[data-toggle="side-navigation"], button[data-toggle="side-navigation"]'),
        sideNavigation = document.querySelector('.side-navigation');

    for (var i = 0; i < toggler.length; i++) {
        toggler[i].onclick = function() {
            if (!sideNavigation.classList.contains('is-active')) {
                this.innerText = 'Hide All Categories';
                sideNavigation.classList.add('is-active');
                sideNavigation.style.maxHeight = sideNavigation.scrollHeight + 'px';
            } else {
                this.innerText = 'Show All Categories';
                sideNavigation.classList.remove('is-active');
                sideNavigation.style.maxHeight = '';
            }
        }
    }
});